'use client';

import React, { useState } from 'react';
import {
    ClipboardList,
    Plus,
    Search,
    Filter,
    Clock,
    CheckCircle2,
    XCircle,
    FileText,
    ChevronDown,
    MoreVertical,
    Wallet,
    Calendar,
    AlertCircle,
    Eye
} from 'lucide-react';

export default function PengajuanDanaPage() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [detailModalOpen, setDetailModalOpen] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState<any>(null);
    const [modalType, setModalType] = useState<'detail' | 'cairkan' | 'bukti' | 'alasan'>('detail');

    const handleViewDetail = (req: any) => {
        setSelectedRequest(req);
        setModalType('detail');
        setDetailModalOpen(true);
    };

    const handleCairkan = (req: any) => {
        setSelectedRequest(req);
        setModalType('cairkan');
        setDetailModalOpen(true);
    };

    const handleViewBukti = (req: any) => {
        setSelectedRequest(req);
        setModalType('bukti');
        setDetailModalOpen(true);
    };

    const handleViewAlasan = (req: any) => {
        setSelectedRequest(req);
        setModalType('alasan');
        setDetailModalOpen(true);
    };

    const submissions = [
        {
            id: 'REQ-2601',
            title: 'Pembelian Meja & Kursi TK A',
            amount: 'Rp 4.500.000',
            category: 'Sarana Prasarana',
            date: '06 Feb 2026',
            status: 'Proses Approval',
            unit: 'PAUD Unit 1',
            description: 'Penambahan inventaris karena siswa bertambah di Unit 1.'
        },
        {
            id: 'REQ-2588',
            title: 'Snack Rapat Koordinasi Guru',
            amount: 'Rp 350.000',
            category: 'Operasional',
            date: '05 Feb 2026',
            status: 'Disetujui',
            unit: 'PAUD Unit 1',
            description: 'Uang makan dan snack untuk rapat mingguan.'
        },
        {
            id: 'REQ-2540',
            title: 'Tinta Printer & Kertas A4',
            amount: 'Rp 850.000',
            category: 'ATK',
            date: '01 Feb 2026',
            status: 'Selesai / Cair',
            unit: 'PAUD Unit 1',
            description: 'Stok bulanan kebutuhan administrasi sekolah.'
        },
        {
            id: 'REQ-2499',
            title: 'Outbound Guru Akhir Tahun',
            amount: 'Rp 5.500.000',
            category: 'Operasional',
            date: '28 Jan 2026',
            status: 'Ditolak',
            unit: 'PAUD Unit 1',
            description: 'Budget operasional bulan Januari sudah tidak mencukupi untuk kegiatan non-esensial.'
        }
    ];

    return (
        <div className="p-6 md:p-10 space-y-8 max-w-7xl mx-auto w-full pb-20 animate-in fade-in duration-500">
            {/* Header */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6">
                <div className="space-y-1">
                    <h1 className="text-4xl font-black tracking-tight text-foreground">
                        Pengajuan <span className="text-primary">Dana</span>
                    </h1>
                    <p className="text-secondary font-bold uppercase tracking-[0.2em] text-[10px]">
                        Operasional • Form Penggunaan Anggaran Unit
                    </p>
                </div>
                <button
                    onClick={() => setIsModalOpen(true)}
                    className="flex items-center gap-3 px-8 py-4 bg-primary text-white rounded-2xl text-[11px] font-black uppercase tracking-widest shadow-xl shadow-primary/20 hover:scale-[1.02] transition-all"
                >
                    <Plus className="w-5 h-5" /> Buat Pengajuan Baru
                </button>
            </div>

            {/* Status Summary Grid */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                {[
                    { label: 'Total Pengajuan', val: '24', icon: ClipboardList, color: 'primary' },
                    { label: 'Dalam Proses', val: '5', icon: Clock, color: 'warning' },
                    { label: 'Disetujui', val: '18', icon: CheckCircle2, color: 'success' },
                    { label: 'Ditolak', val: '1', icon: XCircle, color: 'error' },
                ].map((stat, i) => (
                    <div key={i} className="bg-surface border border-border-main p-6 rounded-4xl flex items-center justify-between group hover:border-primary/30 transition-all shadow-xs">
                        <div className="space-y-1">
                            <p className="text-[9px] font-black text-muted uppercase tracking-widest">{stat.label}</p>
                            <p className="text-2xl font-black text-foreground">{stat.val}</p>
                        </div>
                        <div className={`w-12 h-12 rounded-2xl flex items-center justify-center ${stat.color === 'primary' ? 'bg-primary-soft text-primary' :
                            stat.color === 'warning' ? 'bg-warning-soft text-warning' :
                                stat.color === 'success' ? 'bg-success-soft text-success' : 'bg-error-soft text-error'
                            }`}>
                            <stat.icon className="w-6 h-6" />
                        </div>
                    </div>
                ))}
            </div>

            {/* Main List */}
            <div className="bg-surface border border-border-main rounded-[2.5rem] overflow-hidden shadow-sm">
                <div className="p-8 border-b border-border-main flex flex-col md:flex-row justify-between items-center gap-4">
                    <h3 className="text-sm font-black text-foreground uppercase tracking-widest flex items-center gap-2">
                        <ClipboardList className="w-5 h-5 text-primary" /> Daftar Riwayat Pengajuan
                    </h3>
                    <div className="relative flex-1 max-w-md w-full">
                        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-muted group-focus-within:text-primary transition-colors" />
                        <input
                            type="text"
                            placeholder="Cari ID atau judul..."
                            className="bg-background border border-border-main rounded-xl py-3 pl-11 pr-4 text-xs font-medium outline-none focus:ring-4 focus:ring-primary/5 focus:border-primary/30 transition-all w-full"
                        />
                    </div>
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse">
                        <thead>
                            <tr className="bg-primary-soft/30">
                                <th className="px-8 py-5 text-[10px] font-black text-muted uppercase tracking-[0.15em] border-b border-border-main">Data Pengajuan</th>
                                <th className="px-8 py-5 text-[10px] font-black text-muted uppercase tracking-[0.15em] border-b border-border-main">Kategori & Tanggal</th>
                                <th className="px-8 py-5 text-[10px] font-black text-muted uppercase tracking-[0.15em] border-b border-border-main">Nominal</th>
                                <th className="px-8 py-5 text-[10px] font-black text-muted uppercase tracking-[0.15em] border-b border-border-main">Status</th>
                                <th className="px-8 py-5 text-[10px] font-black text-muted uppercase tracking-[0.15em] border-b border-border-main text-right">Aksi</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-border-main/50">
                            {submissions.map((req) => (
                                <tr key={req.id} className="group hover:bg-primary-soft/10 transition-all cursor-default">
                                    <td className="px-8 py-6">
                                        <div className="flex flex-col">
                                            <span className="text-[10px] font-black text-primary mb-1 tracking-widest">{req.id}</span>
                                            <span className="text-sm font-bold text-foreground group-hover:text-primary transition-colors">{req.title}</span>
                                            <span className="text-[10px] text-muted font-bold mt-1 uppercase">{req.unit}</span>
                                        </div>
                                    </td>
                                    <td className="px-8 py-6">
                                        <div className="flex flex-col">
                                            <span className="text-xs font-bold text-foreground">{req.category}</span>
                                            <span className="text-[10px] text-muted font-bold tracking-tight">{req.date}</span>
                                        </div>
                                    </td>
                                    <td className="px-8 py-6">
                                        <span className="text-sm font-black text-foreground">{req.amount}</span>
                                    </td>
                                    <td className="px-8 py-6">
                                        <div className={`inline-flex px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-wider ${req.status === 'Disetujui' ? 'bg-success-soft text-success' :
                                            req.status === 'Proses Approval' ? 'bg-warning-soft text-warning' : 'bg-primary-soft text-primary'
                                            }`}>
                                            {req.status}
                                        </div>
                                    </td>
                                    <td className="px-8 py-6 text-right">
                                        <div className="flex items-center justify-end gap-2">
                                            {req.status === 'Proses Approval' && (
                                                <button
                                                    onClick={() => handleViewDetail(req)}
                                                    className="flex items-center gap-2 px-4 py-2 bg-white border border-border-main rounded-xl text-[9px] font-black uppercase tracking-widest text-muted hover:bg-primary-soft hover:text-primary hover:border-primary/30 transition-all shadow-xs"
                                                >
                                                    <Eye className="w-3.5 h-3.5" /> Detail
                                                </button>
                                            )}

                                            {req.status === 'Disetujui' && (
                                                <>
                                                    <button
                                                        onClick={() => handleCairkan(req)}
                                                        className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-xl text-[9px] font-black uppercase tracking-widest hover:bg-primary-dark transition-all shadow-lg shadow-primary/20"
                                                    >
                                                        <Wallet className="w-3.5 h-3.5" /> Cairkan
                                                    </button>
                                                    <button
                                                        onClick={() => handleViewDetail(req)}
                                                        className="p-2 bg-white border border-border-main rounded-xl text-muted hover:text-primary transition-all"
                                                    >
                                                        <Eye className="w-3.5 h-3.5" />
                                                    </button>
                                                </>
                                            )}

                                            {req.status === 'Selesai / Cair' && (
                                                <button
                                                    onClick={() => handleViewBukti(req)}
                                                    className="flex items-center gap-2 px-4 py-2 bg-success-soft text-success border border-success/20 rounded-xl text-[9px] font-black uppercase tracking-widest hover:bg-success hover:text-white transition-all"
                                                >
                                                    <FileText className="w-3.5 h-3.5" /> Bukti Cair
                                                </button>
                                            )}

                                            {req.status === 'Ditolak' && (
                                                <button
                                                    onClick={() => handleViewAlasan(req)}
                                                    className="flex items-center gap-2 px-4 py-2 bg-error-soft text-error border border-error/20 rounded-xl text-[9px] font-black uppercase tracking-widest hover:bg-error hover:text-white transition-all"
                                                >
                                                    <AlertCircle className="w-3.5 h-3.5" /> Alasan
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>


            {/* Modal Form Preview (Pop up concept from mindmap) */}
            {isModalOpen && (
                <div className="fixed inset-0 z-60 flex items-center justify-center p-6 bg-black/40 backdrop-blur-sm animate-in fade-in duration-300">
                    <div className="bg-surface w-full max-w-2xl rounded-[2.5rem] shadow-2xl border border-border-main p-10 space-y-8 animate-in zoom-in-95 duration-300 relative">
                        <button
                            onClick={() => setIsModalOpen(false)}
                            className="absolute top-8 right-8 p-2 hover:bg-error-soft hover:text-error rounded-xl transition-all"
                        >
                            <XCircle className="w-6 h-6" />
                        </button>

                        <div className="space-y-1">
                            <h2 className="text-2xl font-black text-foreground">Form <span className="text-primary">Pengajuan Dana</span></h2>
                            <p className="text-[10px] font-black text-muted uppercase tracking-widest">Lengkapi detail penggunaan anggaran unit</p>
                        </div>

                        <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="md:col-span-2 space-y-2">
                                <label className="text-[10px] font-black text-muted uppercase ml-1">Judul Pengajuan</label>
                                <input type="text" placeholder="Contoh: Pembelian Buku Gambar TK A" className="w-full bg-background border border-border-main rounded-xl py-3 px-5 text-sm font-medium outline-none focus:border-primary transition-all" />
                            </div>
                            <div className="space-y-2">
                                <label className="text-[10px] font-black text-muted uppercase ml-1">Kategori Anggaran</label>
                                <select className="w-full bg-background border border-border-main rounded-xl py-3 px-5 text-sm font-medium outline-none focus:border-primary transition-all">
                                    <option>Operasional</option>
                                    <option>Sarana Prasarana</option>
                                    <option>ATK / Konsumsi</option>
                                </select>
                            </div>
                            <div className="space-y-2">
                                <label className="text-[10px] font-black text-muted uppercase ml-1">Estimasi Nominal</label>
                                <div className="relative">
                                    <span className="absolute left-5 top-1/2 -translate-y-1/2 text-xs font-black text-muted">Rp</span>
                                    <input type="number" placeholder="0" className="w-full bg-background border border-border-main rounded-xl py-3 pl-12 pr-5 text-sm font-black outline-none focus:border-primary transition-all" />
                                </div>
                            </div>
                            <div className="md:col-span-2 space-y-2">
                                <label className="text-[10px] font-black text-muted uppercase ml-1">Keterangan / Alasan</label>
                                <textarea rows={3} placeholder="Jelaskan secara detail tujuan penggunaan dana..." className="w-full bg-background border border-border-main rounded-xl py-3 px-5 text-sm font-medium outline-none focus:border-primary transition-all"></textarea>
                            </div>

                            <div className="md:col-span-2 pt-4 flex gap-4">
                                <button type="button" onClick={() => setIsModalOpen(false)} className="flex-1 py-4 bg-background border border-border-main rounded-2xl text-[11px] font-black uppercase tracking-widest hover:bg-error-soft hover:text-error transition-all">Batalkan</button>
                                <button type="button" className="flex-1 py-4 gradient-green text-white rounded-2xl text-[11px] font-black uppercase tracking-widest shadow-xl shadow-primary/20">Kirim Pengajuan</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            {/* Action Detail Modal */}
            {detailModalOpen && selectedRequest && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/40 backdrop-blur-sm animate-in fade-in duration-300">
                    <div
                        className="fixed inset-0"
                        onClick={() => setDetailModalOpen(false)}
                    ></div>
                    <div className="bg-surface w-full max-w-xl rounded-[2.5rem] shadow-2xl border border-border-main p-8 animate-in zoom-in-95 duration-300 relative z-10">
                        {/* Modal Header based on type */}
                        <div className="flex justify-between items-start mb-6">
                            <div>
                                <h3 className="text-xl font-black text-foreground flex items-center gap-3">
                                    {modalType === 'detail' && <><FileText className="w-6 h-6 text-primary" /> Detail Pengajuan</>}
                                    {modalType === 'cairkan' && <><Wallet className="w-6 h-6 text-primary" /> Pencairan Dana</>}
                                    {modalType === 'bukti' && <><CheckCircle2 className="w-6 h-6 text-success" /> Bukti Transfer</>}
                                    {modalType === 'alasan' && <><AlertCircle className="w-6 h-6 text-error" /> Alasan Penolakan</>}
                                </h3>
                                <p className="text-[10px] font-black text-muted uppercase tracking-widest mt-1 ml-1">
                                    {selectedRequest.id} • {selectedRequest.unit}
                                </p>
                            </div>
                            <button
                                onClick={() => setDetailModalOpen(false)}
                                className="p-2 hover:bg-muted rounded-full transition-all"
                            >
                                <XCircle className="w-6 h-6 text-muted-foreground" />
                            </button>
                        </div>

                        {/* Modal Content */}
                        <div className="space-y-6">
                            {/* Common Info */}
                            <div className="p-5 bg-background border border-border-main rounded-3xl space-y-4">
                                <div>
                                    <p className="text-[9px] font-black text-muted uppercase tracking-widest mb-1">Judul Pengajuan</p>
                                    <p className="text-sm font-bold text-foreground">{selectedRequest.title}</p>
                                </div>
                                <div className="flex justify-between items-center pt-3 border-t border-border-main/50">
                                    <div>
                                        <p className="text-[9px] font-black text-muted uppercase tracking-widest mb-1">Nominal</p>
                                        <p className="text-lg font-black text-primary">{selectedRequest.amount}</p>
                                    </div>
                                    <div className="text-right">
                                        <p className="text-[9px] font-black text-muted uppercase tracking-widest mb-1">Tanggal</p>
                                        <p className="text-xs font-bold text-foreground">{selectedRequest.date}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Specific Content per Type */}
                            {modalType === 'detail' && (
                                <div className="space-y-2">
                                    <p className="text-[10px] font-black text-muted uppercase tracking-widest ml-1">Keterangan</p>
                                    <p className="text-sm text-foreground/80 leading-relaxed italic p-4 bg-muted/10 rounded-2xl border border-border-main/50">
                                        "{selectedRequest.description}"
                                    </p>
                                </div>
                            )}

                            {modalType === 'alasan' && (
                                <div className="space-y-2">
                                    <p className="text-[10px] font-black text-error uppercase tracking-widest ml-1">Catatan Penolakan</p>
                                    <div className="p-4 bg-error-soft/30 border border-error/20 rounded-2xl flex gap-3 text-error">
                                        <AlertCircle className="w-5 h-5 shrink-0" />
                                        <p className="text-xs font-medium leading-relaxed">
                                            "{selectedRequest.description}"
                                        </p>
                                    </div>
                                </div>
                            )}

                            {modalType === 'cairkan' && (
                                <div className="space-y-4">
                                    <div className="p-4 bg-primary-soft/30 border border-primary/20 rounded-2xl text-xs font-medium text-primary-dark">
                                        Pastikan Anda telah memverifikasi bukti fisik atau invoice terkait sebelum melakukan pencairan dana ini.
                                    </div>
                                    <button className="w-full py-4 bg-primary text-white rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-primary-dark transition-all shadow-xl shadow-primary/20 flex items-center justify-center gap-2">
                                        <Wallet className="w-4 h-4" /> Konfirmasi Pencairan
                                    </button>
                                </div>
                            )}

                            {modalType === 'bukti' && (
                                <div className="space-y-4 text-center">
                                    <div className="h-32 bg-muted/20 border-2 border-dashed border-muted rounded-3xl flex flex-col items-center justify-center gap-2">
                                        <FileText className="w-8 h-8 text-muted" />
                                        <p className="text-xs font-medium text-muted">Lampiran Bukti Transfer</p>
                                    </div>
                                    <button className="text-xs font-bold text-primary hover:underline">Unduh Bukti Transfer</button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
